(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentAddClassroom, 
        ['$http', '$uibModal', schoolwork12.app.auth.services.authentication,
        function($http, $uibModal, authentication) {

  		var service  = function addClassroomModal(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentAddClassroom,
			    size: 'lg',
			    backdrop: 'static',
			    windowClass: 'large-Modal',
			    controller: ['$scope', '$uibModalInstance',
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing available classroom types");
				
			    //initialize default settings
			    $scope.classroomErrorMesg = "";
			    $scope.classroomErrorOccurred = false;
				$scope.isClassroomSearchBusy = false;
				$scope.isSaveStudentsToClassroomBusy = false;
			    $scope.displayClassroomGrid = false;
			    $scope.classrooms = {'status' : '1', courseName: ''};
				$scope.studentsCount = selectedStudentsCount;
			    
			    $scope.gridOptions = {
			     	enableFiltering : true,
					enableRowSelection : true,
					enableRowHeaderSelection : true,
					showGridFooter : true,
					multiSelect: false,
					enableCellEditOnFocus : true,
					rowHeight: 50
				};
			   
			    //enable Add button only if any row is selected
			    $scope.gridOptions.onRegisterApi = function (gridApi) {
	                $scope.gridApi = gridApi;
			    	$scope.gridApi.selection.on.rowSelectionChanged($scope,function(row){ 
			    		$scope.rowSelected =  row.isSelected;
			    		$scope.seatsData = row.entity.maxSeatsCurrent;
			    		$scope.classroomID = row.entity.classroomId;
			    		$scope.classroomName = row.entity.classroomName;
			    		$scope.classroomType = row.entity.classroomType;
			    		$scope.school = row.entity.school;
			    	});
            	};

            	//build column definitions
				$scope.gridOptions.columnDefs = [
				    { field: 'school', displayName: 'School'},
				    { field: 'classroomId', displayName: 'Classroom ID'},
				    { field: 'classroomName', displayName: 'Classroom Name', width: '27%'},
				    { field: 'classroomType', displayName: 'Classroom Type'},
				    { field: 'primaryTeacher', displayName: 'Primary Teacher'},
				    { field: 'maxSeatsCurrent', displayName: 'Current / Max Seats', enableFiltering: false, width: '9%'},  
				];

				//on click of Display, get available classrooms
			    $scope.getAvailableClassrooms = function(type){
			    	$scope.availableSeatsErrorMesg = '';
			    	if(angular.isUndefined(type)) {
			    			$scope.displayClassroomGrid = false;
			    			$scope.classroomTypeErrorMesg = schoolwork12.app.student.modalErrMessages.selectClassroomType;
			    	} else {
			    		    $scope.isClassroomSearchBusy = true;	
			    		    $scope.availableSeatsErrorMesg = ''		    		    
			    		    //if classroom type is diferent from course = 1
			    		    //set courseName as empty			    		    
			    		    if ($scope.classrooms.type.id != 1){
								$scope.classrooms.courseName = '';
			    		    } 
					     	$http({
					            //get a list of available classrooms by type for Active Students					            
					            url : schoolwork12.app.student.endpoints.getAvailableClassrooms + $scope.classrooms.type.id + '/status/1?courseName=' + $scope.classrooms.courseName,
					            method : 'GET',					            
				        		headers : {
											'X-API-TOKEN' : authentication.getCurrentUser().keycode,
										  }
				            }).success(function (response) {
			            	    console.info("Viewing Classroom details grid");
			            	    $scope.isClassroomSearchBusy = false;
			            	    $scope.displayClassroomGrid = true;
			              	    $scope.gridOptions.data = response;
				            }).error(function(error){
				                console.info('Error in viewing classroom grid....'.concat(angular.toJson(error)));
				                $scope.classroomErrorOccurred = true;
			                	if (error.status == 400) {
									for ( var j = 0; j < error.data._errors.length; j++) {
										$scope.classroomErrorMesg = $scope.classroomErrorMesg + error.data._errors[j] + "\n";
									}
								} else if (error.status == 401 || error.status == 403) {
			                        $scope.classroomErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.classroomErrorMesg = schoolwork12.app.errorMessages.internalError;
			                    }
				            });
				    	}
			    	
			    	};

			    	//on click of Add, save and add students to classroom
			    	$scope.addStudentsToClassroom = function () {
					    	var str = $scope.seatsData;
		              	    var currentSeats = parseInt(str.substr(0,str.indexOf('/')));		              	    
		              	    var maxSeats = parseInt(str.split("/").pop());

		              	    //check available seats for selected students in a classroom
		              	    if (200 - currentSeats < $scope.studentsCount) {
								$scope.noAvailableSeats = true;
								$scope.availableSeatsErrorMesg = schoolwork12.app.student.modalErrMessages.noAvailableSeats;
							} 
							else {
								$scope.noAvailableSeats = false;
								$scope.isSaveStudentsToClassroomBusy = true;
								console.log($scope.school)
								//save list of students to the selected classroom
				             	$http({
					              	url : schoolwork12.app.student.endpoints.addStudentsToClassroom + $scope.classroomID + '/students',
					              	method : "POST",
					              	data : {
											 "classroomName": $scope.classroomName,
											 "classroomtype": $scope.classroomType,
											 "schoolAbbr": $scope.school,
											 "students": selectedStudents, 
											},
				        		  	headers : {
												'X-API-TOKEN' : authentication.getCurrentUser().keycode,
											}
					              	}).success(function (response) {
					              		console.info("Students added to classroom successfully", response);
			            	   			$scope.saveErrorOccurred = false;
					              		$uibModalInstance.close();
					              	}).error(function(error){ 
					              		$scope.saveErrorOccurred = true;
					              		$scope.saveStudentsFailedErrorMesg = schoolwork12.app.student.modalErrMessages.saveStudentsToClassroomFailed;
					                	console.info('Error in adding students to classroom....'.concat(angular.toJson(error)));
					                	$scope.classroomErrorOccurred = true;
					                	/*if (error.status == 400) {
											for ( var j = 0; j < error.data._errors.length; j++) {
												$scope.classroomErrorMesg = $scope.classroomErrorMesg + error.data._errors[j] + "\n";
											}
										} else if (error.status == 401 || error.status == 403) {
					                        $scope.classroomErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
					                    } else {
					                        $scope.classroomErrorMesg = schoolwork12.app.errorMessages.internalError;
					                    }*/
					            });
							}
					}; 

					var getClassroomTypes = function(){
						console.log("got in");
						$http({
							url : schoolwork12.app.student.endpoints.getAvailableClassroomsTypes,
							method : "GET",
							data : {},
							headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
						}).success(function(response){
							console.info("All ClassroomTypes retrieved", response);
							$scope.classroomTypes = response;
						}).error(function(error){
							console.error("There was an error while retrieving classroomtypes".concat(angular.toJson(error)));
						})
					};

					$scope.classroomTypes = getClassroomTypes();

				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};
			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));